// Accordian box
export const ACCORDIAN_BOX = 'accordian_box';
export const ACCORDIAN_BOX_DELETE_ICON = 'accordian_box_delete_icon';
export const ACCORDIAN_BOX_OPEN_ICON = 'accordian_box_close_icon';
export const ACCORDIAN_BOX_CLOSE_ICON = 'accordian_box_open_icon';

// Multi step drag & drop box
export const MULTI_STEP_DRAG_AND_DROP_ADD_NEW_RECORD = 'msdd_add_new_record';

// Image Field
export const IMAGE_FIELD_DROP_ZONE_INPUT = 'image_field_drop_zone_input';
export const IMAGE_FIELD_DROP_ZONE_SPINNER = 'image_field_drop_zone_spinner';
export const IMAGE_FIELD_DROP_ZONE_PREVIEW = 'image_field_drop_zone_preview';
export const IMAGE_FIELD_DROP_ZONE_CONTENT = 'image_field_drop_zone_content';
export const IMAGE_FIELD_DROP_ZONE_CHANGE_IMAGE = 'image_field_drop_zone_change_image';
export const IMAGE_FIELD_DROP_ZONE_CROSS_ICON = 'image_field_drop_zone_cross_icon';
export const IMAGE_FIELD_UPLOAD_BUTTON_SPINNER = 'image_field_upload_button_spinner';
export const IMAGE_FIELD_UPLOAD_BUTTON = 'image_field_upload_button';
export const IMAGE_FIELD_UPLOAD_BUTTON_FILE_INPUT = 'image_field_upload_button_file_input';
export const IMAGE_FIELD_UPLOAD_BUTTON_IMAGE_DISPLAY = 'image_field_upload_button_image_display';

//App Version admin
export const VERSION_ADMINISTRATION_DEPLOYABLE_CHECBOX = 'version_administration_deployable_checkbox';
export const VERSION_ADMINISTRATION_CAN_AUTO_UPDATE_SELECT = 'version_administration_can_auto_update_select';
export const VERSION_ADMINISTRATION_FORM_SUBMIT_BUTTON = 'version_administration_form_submit_button';

//App version action
export const VIEW_APP_VERSION = 'view_app_version';
export const DELETE_APP_VERSION = 'delete_app_version';

//App version highlights
export const APP_VERSION_HIGHLIGHTS_FORM = 'app_version_highlights_form';
export const SUBMIT_APP_VERSION_HIGHLIGHTS = 'submit_app_version_highlights';

//App version media
export const APP_VERSION_MEDIA_FORM = 'app_version_media_form';
export const SUBMIT_APP_VERSION_MEDIA = 'submit_app_version_media';

//App version links
export const APP_VERSION_LINKS_DOCUMENTATION_URL_INPUT = 'app_version_links_documentation_url';
export const APP_VERSION_LINKS_PURCHASE_URL_INPUT = 'app_version_links_purchase_url';
export const APP_VERSION_LINKS_LICENSE_URL_INPUT = 'app_version_links_license_url';
export const APP_VERSION_LINKS_EULA_URL_INPUT = 'app_version_links_eula_url';
export const APP_VERSION_LINKS_SAVE_BUTTON = 'app_version_links_save_button';

//App compability table
export const APP_VERSION_COMPATIBILITIES_SAVE_BUTTON = 'app_version_compatiblities_save_button';
export const APP_VERSION_COMPATIBILITIES_FORM = 'app_version_compatiblities_form';

// App Version instruction ui
export const APP_VERSION_INSTRUCTIONS_SAVE_BUTTON = 'app_version_instructions_save_button';

// App Version details ui
export const APP_VERSION_DESCRIPTOR_FIELD = 'app_version_descriptor_field';
export const APP_VERSION_VERSION_VISIBILITY_FIELD = 'app_version_version_visibility_field';
export const APP_VERSION_PAYMENT_MODEL_FIELD = 'app_version_payment_model_field';
export const APP_VERSION_SCOPES_FIELD = 'app_version_scopes_field';
export const APP_VERSION_IS_BETA_FIELD = 'app_is_beta_field';
export const APP_VERSION_LICENSE_FIELD = 'app_version_license_field';
export const APP_VERSION_IS_SUPPORTED_FIELD = 'app_version_is_supported_field';
export const APP_VERSION_RELEASE_SUMMARY_FIELD = 'app_version_release_summary_field';
export const APP_VERSION_BONTERMS_FIELD = 'app_version_bonterms_field';
export const APP_VERSION_PARTNER_SPECIFIC_TERMS_FIELD = 'app_version_partner_specific_terms_field';
export const APP_VERSION_APP_FILE_FIELD = 'app_version_app_file_field';